import { render, staticRenderFns } from "./ResendEmailLinkModal.vue?vue&type=template&id=9888f3c6&"
import script from "./ResendEmailLinkModal.vue?vue&type=script&lang=js&"
export * from "./ResendEmailLinkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports